import Promise from 'promise-polyfill';
import svg4everybody from 'svg4everybody';
import 'picturefill';

if (!window.Promise) {
	window.Promise = Promise;
}

svg4everybody(); // allows external svgsprites in ie
